import * as d3 from 'd3';
import moment from 'moment';
import Axis from './Axis.js';

const quarters = [
  ['01', '02', '03'],
  ['04', '05', '06'],
  ['07', '08', '09'],
  ['10', '11', '12'],
];

export default class UnitsQuarterAxis extends Axis {
  constructor(props) {
    super(props);

    const customMonthFormat = d3.timeFormat('%m');

    this.axis = d3
      .axisBottom(this.xScale)
      .ticks(d3.timeMonth.every(3))
      .tickFormat((date) => {
        const quarterStart = d3.timeMonth(date);
        const firstMonth = customMonthFormat(quarterStart);
        return `Q${quarters.findIndex((quarter) => quarter.includes(firstMonth)) + 1}`;
      });
  }

  positionText() {
    const {
      chart,
      options: { width, scaleType },
    } = this.props;

    if (scaleType === 'year') {
      chart
        .selectAll('.quarter .tick text')
        .attr('transform', `translate(${width / 16 / 2}, 18)`);
    } else {
      chart
        .selectAll('.quarter .tick text')
        .attr('transform', `translate(${width / 4 / 2}, 0)`);
    }

    return this;
  }

  setCurrentQuarter() {
    const {
      chart,
      options: { scaleType },
    } = this.props;

    if (scaleType === 'quarter') {
      chart.selectAll('.quarter .tick text').attr('class', (value) => {
        if (moment(value, 'YYYY-MM-DD').isSame(moment(), 'month')) {
          return 'current-quarter';
        }
      });
    }
    return this;
  }

  addMonthGrid() {
    const {
      chart,
      options: { height, scaleType },
    } = this.props;
    chart
      .selectAll('.quarter .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', `${scaleType === 'year' ? '3.3' : false}`)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.quarter .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.quarter')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.positionText().addMonthGrid().removeDomainPath().setCurrentQuarter();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis quarter')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.positionText().addMonthGrid().removeDomainPath().setCurrentQuarter();
  }
}
